<!-- 付款单信息 -->
<template>
  <base-form
    v-model="formData"
    :options="options"
    ref="formData"
    :disabled="!canEdit"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import BaseForm from '@/components/form/base-form';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/financeCenter/withholding';
  import DataBaseAPI from '@/api/dataBase';
  import { mapState } from 'vuex';
  // import searchTable from '@/components/form-item/search-table';
  import XEUtils from 'xe-utils';
  export default {
    name: 'accruedInfo',
    components: {
      BaseForm,
      // ajaxSelect,
      // searchTable,
    },
    props: ['companyList', 'detail', 'query', 'canEdit', 'accruedInfo'],
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        departmentList: [], // 部门列表
        isInsureTypeList: [
          { id: '0', name: '否' },
          { id: '1', name: '是' },
        ],
        editConfig: {},
        tableToolbar: {},
        fileTableLoad: false,
        formData: {
          docNo: '', // 单据编号
          accruedCompanyCode: '', // 申请单公司代码
          accruedCompanyName: '', // 申请单公司名称
          accruedDepartmentCode: '', // 申请单部门代码
          accruedDepartmentName: '', // 申请单部门名称
          contractNo: '', //采购合同号
          supplierNo: null, //供应商编码
          supplierName: null, //供应商名称
          supplierType: null, //供应商类型
          accruedType: '', //预提类型
          currencyCode: '', // 币种编码
          currencyName: '', // 币种名称
          exchangeType: '', // 汇率类型(字典)
          exchangeRate: '', // 汇率
          exchangeDate: date, // 汇率日期
          ledgerCode: '', //账套
          accruedAmount: 0, //预提原币总金额
          accruedWithoutTaxAmount: 0, //预提原币不含税金额
          accruedTaxAmount: 0, //预提原币税额
          taxRate: 0, //税率%
          companyAccruedAmount: 0, //预提本币总金额
          companyAccruedWithoutTaxAmount: 0, //预提本币不含税金额
          companyAccruedTaxAmount: 0, //预提本币税额
          docDate: date, //制单日期
          docStatus: '', //单据状态
          accountingStatus: '', //入账状态
          reversePostDate: date, //冲销入账日期
          reverseStatus: '', //冲销入账状态
          tradeType: '', //贸易类型
        }, // 顶部表单的数据
        currency: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        currencyList() {
          return this.$baseRequest.getDictListByType('all_currency');
        },
      }),
      //顶部表单配置
      options() {
        const data = this.formData;
        return [
          {
            //申请单公司代码
            prop: 'accruedCompanyCode',
            type: 'select',
            options: this.companyList,
            label: this.$t('withholdingList.withholdInfoAdd.column.accruedCompanyCode'),
            clearable: true,
            required: true,
          },
          {
            //申请单部门代码
            prop: 'accruedDepartmentCode',
            type: 'select',
            options: this.departmentList,
            label: this.$t('withholdingList.withholdInfoAdd.column.accruedDepartmentCode'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //费用/预提类型
            prop: 'accruedType',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.accruedType'),
            dictType: 'accrued_Type',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //合同号
            prop: 'contractNo',
            label: this.$t('withholdingList.withholdInfoAdd.column.contractNo'),
            type: 'searchTable',
            searchType: 'contract',
            extraData: this.getContractNoData(),
            valueType: 'object',
            code: 'contractNo',
            placeholder: this.$t('withholdingList.placeholder.contractNoPlaceholder'),
            isMultiple: true,
            required: true,
            currentValue: data.contractNo,
          },
          {
            //供应商
            prop: 'supplierName',
            label: this.$t('withholdingList.withholdInfoAdd.column.supplierName'),
            type: 'searchTable',
            searchType: 'supplier',
            name: 'supplierName',
            extraData: {
              departmentCode: this.formData.accruedDepartmentCode, //部门
              companyCode: this.formData.accruedCompanyCode, //公司
            },
            valueType: 'object',
            code: 'supplierNo',
            getName: 'partnerZhName',
            getCode: 'partnerCode',
            placeholder: this.$t('withholdingList.placeholder.supplierPlaceholder'),
            isMultiple: true,
            required: true,
            // currentValue: data.supplierName
          },
          {
            //币种
            prop: 'currencyCode',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.currencyCode'),
            clearable: true,
            dictType: 'all_currency',
            disabled: this.formData.accruedType == 'YT1',
            required: true,
          },
          {
            //汇率日期
            prop: 'exchangeDate',
            type: 'date',
            label: this.$t('withholdingList.withholdInfoAdd.column.exchangeDate'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //汇率类型、汇率
            prop: 'exchangeType',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.exchangeRate'),
            clearable: true,
            dictType: 'exchange_type',
            disabled: this.formData.accruedType == 'YT1',
            required: true,
            moreInput: true,
            ruleType: 'object',
            validatorKey: this.formData.exchangeRate,
            moreProp: 'exchangeRate',
            morePlaceholder: this.$t('withholdingList.placeholder.exchangeRatePlaceholder'),
            moreClearable: true,
            moreRequired: this.formData.accruedType == 'YT1',
            moreDisabled:
              this.formData.exchangeType == 'Cooperate' || this.formData.exchangeType == 'spot',
          },
          {
            //预提原币总金额--必填
            prop: 'accruedAmount',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.accruedAmount'),
            min: this.formData.accruedType == 'YT1' ? '-99999999999' : '0',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //预提原币不含税金额 --必填
            prop: 'accruedWithoutTaxAmount',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.accruedWithoutTaxAmount'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //预提原币税额--必填
            prop: 'accruedTaxAmount',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.accruedTaxAmount'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //税率%--必填
            prop: 'taxRate',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.taxRate'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            //预提本币总金额 --必填
            prop: 'companyAccruedAmount',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.companyAccruedAmount'),
            clearable: true,
            disabled: true,
            required: true,
          },
          {
            //预提本币不含税金额 --必填
            prop: 'companyAccruedWithoutTaxAmount',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.companyAccruedWithoutTaxAmount'),
            clearable: true,
            disabled: true,
            required: true,
          },
          {
            //预提本币税额 --必填
            prop: 'companyAccruedTaxAmount',
            type: 'amountNumber',
            precision: this.$globalVar.aPoint,
            label: this.$t('withholdingList.withholdInfoAdd.column.companyAccruedTaxAmount'),
            clearable: true,
            disabled: true,
            required: true,
          },
          {
            //制单日期
            prop: 'docDate',
            type: 'date',
            label: this.$t('withholdingList.withholdInfoAdd.column.docDate'),
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            // 单据编号
            prop: 'docNo',
            type: 'input',
            label: this.$t('withholdingList.withholdInfoAdd.column.docNo'),
            placeholder: this.$t('withholdingList.placeholder.docNoPlaceholder'),
            // clearable: false,
            disabled: true,
          },
          {
            //单据状态
            prop: 'docStatus',
            type: 'dict',
            label: this.$t('withholdingList.withholdInfoAdd.column.docStatus'),
            dictType: 'accrued_status',
            placeholder: this.$t('withholdingList.placeholder.docNoPlaceholder'),
            disabled: true,
          },
          {
            //入账状态
            prop: 'accountingStatus',
            label: this.$t('withholdingList.withholdInfoAdd.column.accountingStatus'),
            type: 'dict',
            dictType: 'post_status',
            clearable: true,
            disabled: true,
          },
          // {// 冲销入账日期
          //   prop: "reversePostDate",
          //   type:'date',
          //   label: this.$t("withholdingList.withholdInfoAdd.column.reversePostDate"),
          //   clearable: true,
          //   disabled: false,
          //   required: true
          // },
          // {//冲销入账状态
          //   prop: "reverseStatus",
          //   label: this.$t("withholdingList.withholdInfoAdd.column.reverseStatus"),
          //   type: "dict",
          //   dictType:'post_status',
          //   disabled: true,
          //   clearable: true,
          // },
        ];
      },
    },
    mounted() {
      this.formData.accruedPersonNo = this.userInfo.userCode;
      this.formData.accruedPersonName = this.userInfo.userName;
    },
    watch: {
      // 监听表单变化
      formData: {
        handler: XEUtils.debounce(function () {
          this.$emit('updateForm', this.formData);
        }, 100),
        deep: true,
      },
    },
    methods: {
      handleChange(v, prop) {
        this.formData[prop] = v[prop];
        if (prop == 'accruedCompanyCode') {
          //公司编码
          this.formData.accruedCompanyCode = v[prop];
          this.formData.accruedDepartmentCode = '';
          this.formData.accruedDepartmentName = '';
          this.formData.supplierName = null; //供应商Name
          this.formData.supplierNo = null; //供应商code
          this.$emit('resetRowInfo');
          if (!v[prop]) return;
          this.formData.accruedCompanyName = this.companyList.find(
            (it) => it.value == v[prop]
          ).label;
          this.getdepartmentList(this.formData.accruedCompanyCode);
          this.getLedger(this.formData.accruedCompanyCode);
        } else if (prop == 'accruedDepartmentCode') {
          //部门编码
          this.formData.accruedDepartmentCode = v[prop];
          this.formData.accruedDepartmentName = this.departmentList.find(
            (it) => it.value == v[prop]
          ).label;
          this.formData.supplierName = null; //供应商Name
          this.formData.supplierNo = null; //供应商code
        } else if (prop == 'accruedType') {
          //预提状态
          this.$emit('resetRowInfo');
          this.formData.contractNo = null;
          this.formData.supplierName = null;
          this.formData.accruedAmount = 0;
        } else if (prop == 'contractNo') {
          //采购合同号
          this.$emit('resetRowInfo');
          if (!v[prop]) return;
          let contractData = v[prop];
          this.formData.contractNo = v[prop][0].contractNo;
          this.accruedInfo.detailList = []; //明细置空
          this.getContractData(contractData); //合同信息
        } else if (prop == 'supplierName') {
          //供应商弹窗
          this.formData.contractNo = '';
          this.$emit('resetRowInfo');
          if (!v[prop]) return;
          this.formData.supplierName = v[prop][0].partnerZhName; //供应商Name
          this.formData.supplierNo = v[prop][0].partnerCode; //供应商code
          this.formData.supplierType = v[prop][0].partnerType; //供应商状态
        } else if (prop == 'currencyCode') {
          //币种
          this.formData.currencyName =
            this.currencyList.find((i) => i.currencyCode === v[prop]) &&
            (this.currencyList.find((i) => i.currencyCode === v[prop]).currencyName || '');
          this.selectTaxRate();
        } else if (prop == 'accruedAmount') {
          //预提原币总金额
          this.formData.accruedAmount = v[prop];
          this.amountCalculate(); //金额计算
        } else if (prop == 'accruedWithoutTaxAmount') {
          //预提原币不含税金额
          this.formData.accruedWithoutTaxAmount = v[prop];
          this.amountCalculate('accruedWithoutTaxAmount', this.formData.accruedWithoutTaxAmount);
        } else if (prop == 'accruedTaxAmount') {
          //税额
          this.formData.accruedTaxAmount = v[prop];
          this.amountCalculate('accruedTaxAmount', this.formData.accruedTaxAmount);
        } else if (prop == 'taxRate') {
          // 税率
          this.formData.taxRate = v[prop];
          this.amountCalculate(); //金额计算
        } else if (prop == 'exchangeRate') {
          this.selectTaxRate();
          this.amountCalculate(); //金额计算
        }
      },
      // 获取公司对应本币位
      getLedger(companyCode) {
        this.$baseRequest.getLedger(companyCode).then((res) => {
          if (res.length > 0) {
            //如果换公司，则币种都默认变化
            this.formData.companyCurrencyCode = res[0].currencyCode;
            this.formData.companyCurrencyName = res[0].currencyName;
            //默认汇率类型
            this.formData.exchangeType = res[0].defaultExchangeType;
            this.formData.currencyCode = res[0].currencyCode;
            this.formData.currencyName = res[0].currencyName;
            this.formData.ledgerCode = res[0].ledgerCode;
            this.selectTaxRate();
          } else {
            //没有查询到公司账套
            this.formData.companyCurrencyCode = null;
            this.formData.exchangeType = null;
            this.formData.exchangeRate = null;
            this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
          }
        });
      },
      //获取汇率
      getRate() {
        if (this.formData.currencyCode || this.formData.companyCurrencyCode) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: this.formData.currencyCode,
            toCurrencyCode: this.formData.companyCurrencyCode,
            exchangeDate: this.formData.exchangeDate,
          };
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.formData.exchangeRate = res.positiveRate;
            } else {
              this.formData.exchangeRate = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      //获取采购合同相关信息
      getContractData(res) {
        //预提类型为出口运费和出口佣金，"供应商/客户"展示客户内容
        if (this.formData.accruedType == 'YT16' || this.formData.accruedType == 'YT17') {
          this.formData.supplierName = res[0].customerName;
          this.formData.supplierNo = res[0].customerNo;
        } else {
          this.formData.supplierName = res[0].supplierName;
          this.formData.supplierNo = res[0].supplierNo;
        }
        this.formData.currencyCode = res[0].contractCurrency;
        this.formData.currencyName = res[0].contractCurrencyName;
        this.formData.tradeType = res[0].tradeType;
        this.selectTaxRate();
      },
      // 获取部门
      getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 采购合同查询
      getContractNoData() {
        const { adminFlag } = this.userInfo;
        let params = {
          adminFlag,
          contractStatus: 'ZT03',
          contractCategory:
            this.formData.accruedType == 'YT16' || this.formData.accruedType == 'YT17'
              ? 'sales'
              : 'purchase',
          supplierNo:
            this.formData.accruedType == 'YT16' || this.formData.accruedType == 'YT17'
              ? null
              : this.formData.supplierNo,
        };
        return params;
      },
      //币种选择
      selectCurrency(v) {
        this.formData.currencyName = this.currencyList.find(
          (i) => i.currencyCode === v
        ).currencyName;
        this.selectTaxRate();
      },
      // 汇率值获取
      selectTaxRate() {
        // let taxRate;
        if (
          this.formData.companyCurrencyCode &&
          this.formData.currencyCode &&
          this.formData.companyCurrencyCode === this.formData.currencyCode
        ) {
          this.formData.exchangeRate = 1;
        } else if (this.formData.companyCurrencyCode && this.formData.currencyCode) {
          this.getRate();
        }
      },
      // 获取汇率
      selectExchangeType(fromCurrencyCode) {
        return this.$axios.post(API.GET_CURRENCY_EXCHANGE, { fromCurrencyCode }).then((res) => {
          if (res.data.code !== 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 金额计算
      amountCalculate(prop, value) {
        if (prop == 'accruedTaxAmount') {
          //税额
          //预提原币税额 = 预提原币总金额-预提原币不含税金额value
          this.formData.accruedTaxAmount = value;
          //预提原币不含税金额=预提原币总金额/（1+税率）
          this.formData.accruedWithoutTaxAmount = this.$cal.calCommon(
            this.formData.accruedAmount,
            this.formData.accruedTaxAmount,
            '-',
            'amount'
          );
        } else {
          //预提原币不含税金额=预提原币总金额/（1+税率）
          this.formData.accruedWithoutTaxAmount =
            prop == 'accruedWithoutTaxAmount'
              ? value
              : this.$cal.calCommon(
                  this.formData.accruedAmount,
                  this.$cal.calCommon(1, this.$cal.calCommon(this.formData.taxRate, 100, '/'), '+'),
                  '/',
                  'amount'
                );
          //预提原币税额 = 预提原币总金额-预提原币不含税金额
          this.formData.accruedTaxAmount = this.$cal.calCommon(
            this.formData.accruedAmount,
            this.formData.accruedWithoutTaxAmount,
            '-',
            'amount'
          );
        }
        // 预提本币总金额 = 预提原币总金额*汇率
        this.formData.companyAccruedAmount = this.$cal.calCommon(
          this.formData.accruedAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
        // 预提本币不含税金额 = 预提原币不含税金额*汇率
        this.formData.companyAccruedWithoutTaxAmount = this.$cal.calCommon(
          this.formData.accruedWithoutTaxAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
        // 预提本币税额 = 预提原币税额*汇率
        this.formData.companyAccruedTaxAmount = this.$cal.calCommon(
          this.formData.accruedTaxAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
      },
    },
  };
</script>
